module.exports = __webpack_public_path__ + "media/country_flags/zm-dfcc3b74.png";